import computeClassName from '../../../../../../../utils/computeClassName';
import computeTagName from '../../../../../../../utils/computeTagName';
import CCPlaceholderImagePictureMedium from '../../Picture/Medium';

const constants = Object.freeze({
  CLASSNAME_BASE: 'bg-cc-gray-05 rounded-sm flex flex-row items-center justify-center',
  TAG_DEFAULT: 'div'
});

const propsDefaults = Object.freeze({
  placeholderTitle: 'Image placeholder',
  tag: constants.TAG_DEFAULT
})
export default function CCPlaceholderImageLargeCustomSize(
  {
    placeholderTitle = propsDefaults.placeholderTitle,
    tag = propsDefaults.tag,
    className
  }
) {
  const ComputedTagName = computeTagName(tag, constants.TAG_DEFAULT)
  const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);
  return (
    <ComputedTagName className={computedClassName} title={placeholderTitle}>
      <CCPlaceholderImagePictureMedium/>
    </ComputedTagName>
  );
}
